import axios from "axios";
// 创建axios实例，设置配置得默认值
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // 这里写接口的http地址，
  timeout: 20000, // 设置请求超时的默认值
});
// console.log(process.env, '====================');
// 设置请求拦截器
request.interceptors.request.use(
  /*  (config) => {
     console.log(config, "config");
     // 判断当前是否有token，有则在请求头上加上token
     if (
       localStorage.getItem("token") &&
       config.url !== "/distribution/system/eventTracking"
     ) {
       config.headers.Authorization = localStorage.getItem("token");
     }
     return config;
   },
   (error) => {
     console.log(error);
     return Promise.reject(error);
   } */
);
// 设置响应拦截
request.interceptors.response.use(
  (response) => {
    const res = response.data;
    return res;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 向外暴露axios实例
export default request;
